import images from "@/assets/images";
import React from "react";

interface IWindowMacProps {
  next: () => void;
}
const WindowMac: React.FC<IWindowMacProps> = ({ next }) => {
  return (
    <div className="hide-scroll-bar mx-[30px] flex h-full max-h-full flex-col items-center overflow-y-auto pb-[30px] pt-[65px]">
      <img src={images.PC1} className="mb-[52px] w-full" />
      <p className="mb-[8px] text-[16px] leading-[22px] text-[#fff]">虎牙直播客户端</p>
      <p className="mb-[20px] text-[32px] leading-[45px] text-[#fff]">沉浸享受精彩直播</p>
      <p className="mb-[4px] text-[14px] leading-[20px] text-[#FFFFFF99]">请在电脑访问操作</p>
      <p className="mb-[50px] text-[14px] leading-[22px] text-[#FFFFFF99]">
        https://hd.huya.com/download/
      </p>
      <img src={images.iconDown1} className="h-[24px] w-[24px]" onClick={next} />
    </div>
  );
};

export default WindowMac;
